import React from "react";
import { Button } from "@mui/material";

const CustomButton = ({
  color,
  backgroundColor,
  variant,
  text,
  onClick,
  disabled,
  getStarted,
  style,
  testId
}) => {
  const shadow = disabled
    ? "0 12px 24px -10px #9d9ea4"
    : variant === "outlined"
    ? "0 12px 20px -10px rgba(8, 76, 149, 0.4)"
    : "0 12px 24px -10px rgba(16, 109, 186, 0.6)";
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      variant={variant}
      sx={{
        borderRadius: "100px",
        padding: "14px 24px",
        fontFamily: "FSElliotPro",
        fontSize: "16px",
        lineHeight: 1.25,
        letterSpacing: "0.32px",
        textTransform: "none",
        width: "100%",
      }}
      style={{
        color: color,
        backgroundColor: disabled ? "#9d9ea4" : backgroundColor,
        borderColor: variant === "outlined" && color,
        boxShadow: getStarted ? "none" : shadow,
        fontWeight: text === "Chat with us on WhatsApp" ? "400" : "700",
        ...(style || {})
      }}
      data-cy={testId}
    >
      {text}
    </Button>
  );
};

export default CustomButton;